import { ChainButtonTextShadow, ChainItemBase } from "../chain_offer_screen/chain_item_base.js";
import { requestChainVideoStep } from "./chain_video_purchase_service.js";

export { ChainItemType as ChainVideoItemType } from "../chain_offer_screen/chain_item_base.js";
export type { ChainReward as ChainVideoReward, ChainItemConfig as ChainVideoItemConfig } from "../chain_offer_screen/chain_item_base.js";

export class ChainVideoItem extends ChainItemBase
{
  protected async requestStep( offer_id: string, step_id: string, type: 'paid' | 'free' | 'rewarded' ): Promise<boolean>
  {
    return await requestChainVideoStep( offer_id, step_id, type ) === 'claimed';
  }

  /** The video screen's buttons sit on flat art, so a drop shadow only muddies the label. */
  protected buttonTextShadow(): ChainButtonTextShadow | null
  {
    return null;
  }

  public override name(): string
  {
    return "ChainVideoItem";
  }
}
